import * as React from 'react';
export default function State(props) {
    const { value = '', record = {}, options = {} } = props;
    // 兼容之前直接判断 conditionValue 显示红色的逻辑
    const { conditionKey = 'pkStatus', conditionValue = '破损' } = options;
    if (record[conditionKey] === conditionValue) {
        return React.createElement("span", { className: 'pkStatus' }, value);
    }
    return React.createElement(React.Fragment, null, value);
}
